import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import {
  AgenceSettingsDatatableMeta,
  IAgenceSettingsDatatable,
} from './AgenceSettingsDatatableHandlerMeta';

export default function AgenceSettingsDatatableHandler() {
  // const editUsersModal = React.useRef<any>(null);
  // const deleteUsersModal = React.useRef<any>(null);

  const data: IAgenceSettingsDatatable[] = [
    {
      minBin: '',
      maxBin: '',
      sequenceBin: '',
    },
    {
      minBin: '',
      maxBin: '',
      sequenceBin: '',
    },
    {
      minBin: '',
      maxBin: '',
      sequenceBin: '',
    },
  ];

  // const handleEdit = (row: any) => {
  //   editUsersModal?.current?.onOpen();
  // };

  // const handleDelete = (row: any) => {
  //   deleteUsersModal?.current?.onOpen();
  // };

  return (
    <>
      <CustomReactTable
        data={data}
        columns={AgenceSettingsDatatableMeta.columns()}
      />

      {/* <CustomAppModal
        title="Editer Le Status des utilisateurs"
        ref={editUsersModal}
        actionBtnText="Editer"
        actionBtnClick={() => editUsersModal?.current?.onClose()}
      >
        <CustomFormControl label="Status">
          <CustomInputSelect
            meta={{
              name: 'status',
              options: [
                { label: 'Actif', value: 'active' },
                { label: 'Vérouillé', value: 'lock' },
              ],
            }}
          />
        </CustomFormControl>
      </CustomAppModal>

      <CustomAppModal
        title="Confirmer la suppression"
        ref={deleteUsersModal}
        actionBtnText="Supprimer"
        actionBtnClick={() => deleteUsersModal?.current?.onClose()}
      >
        <CC.Text>Voulez-vous vraiment supprimer ?</CC.Text>
      </CustomAppModal> */}
    </>
  );
}
